import {
	TableContainer,
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell,
	useMediaQuery,
	useTheme,
	Grid,
	Card,
	CardContent,
	CardActions,
} from '@mui/material';
import {
	CerebroHeading,
	CerebroLabel,
	CerebroSecondaryButton,
	CerebroText,
	CerebroTextButton,
} from '../../shared/components';
import { StagedDiligenceRequestUpload } from '../../shared/models';
import { DateUtils, EnumUtils } from '../../shared/utils';

interface DiligenceUploadListProps {
	uploads: StagedDiligenceRequestUpload[];
	onView: (upload: StagedDiligenceRequestUpload) => void;
}

export const DiligenceUploadList: React.FC<DiligenceUploadListProps> = ({ uploads, onView }) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	return isMobile ? (
		<Grid container spacing={2} alignItems="stretch">
			<Grid item>
				<CerebroHeading size="h3" component="h3">
					Pending Diligence Requests
				</CerebroHeading>
			</Grid>
			{uploads.map(upload => (
				<Grid key={upload.guid} sx={{ marginBottom: 3 }} item xs={12}>
					<Card
						elevation={3}
						sx={{
							display: 'flex',
							justifyContent: 'space-between',
							flexDirection: 'column',
							height: '100%',
							marginBottom: 2,
						}}
					>
						<CardContent sx={{ paddingBottom: '0 !important' }}>
							<Grid container sx={{ marginBottom: 2 }}>
								<Grid item xs={8} sx={{ display: 'flex' }}>
									<CerebroLabel sx={{ fontWeight: 'bold', alignSelf: 'center' }}>
										{DateUtils.FormatStringAsShortDate(upload.createdOn.toString())}
									</CerebroLabel>
								</Grid>
								<Grid item xs={4} sx={{ textAlign: 'right' }}>
									<CerebroLabel sx={{ fontWeight: 'bold', alignSelf: 'center' }}>
										{upload.items.length} Task(s)
									</CerebroLabel>
								</Grid>
							</Grid>
							<CerebroText>
								{EnumUtils.GetDiligenceRequestTypeDescription(upload.diligenceType)}
							</CerebroText>
							<CerebroText>Uploaded by {upload.fullName}</CerebroText>
						</CardContent>
						<CardActions
							sx={theme => ({
								alignItems: 'flex-end',
								backgroundColor: theme.palette.gray.background,
								borderTop: `1px solid ${theme.palette.divider}`,
								justifyContent: 'space-between',
							})}
						>
							<CerebroTextButton size="small" onClick={() => onView(upload)}>
								Complete Import
							</CerebroTextButton>
						</CardActions>
					</Card>
				</Grid>
			))}
		</Grid>
	) : (
		<TableContainer sx={{ marginBottom: 3 }}>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell colSpan={5}>Pending Diligence Requests</TableCell>
					</TableRow>
					<TableRow>
						<TableCell>Date Started</TableCell>
						<TableCell>Type</TableCell>
						<TableCell>Uploaded By</TableCell>
						<TableCell># Tasks</TableCell>
						<TableCell>Actions</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{uploads.map(upload => (
						<TableRow key={upload.guid}>
							<TableCell>{DateUtils.FormatStringAsShortDate(upload.createdOn.toString())}</TableCell>
							<TableCell>{EnumUtils.GetDiligenceRequestTypeDescription(upload.diligenceType)}</TableCell>
							<TableCell>{upload.fullName}</TableCell>
							<TableCell>{upload.items.length}</TableCell>
							<TableCell>
								<CerebroSecondaryButton onClick={() => onView(upload)}>
									Complete Import
								</CerebroSecondaryButton>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
};
